module.exports = __webpack_public_path__ + "img/PM_A01_back_fr.aae8bf68.png";